import * as tslib_1 from "tslib";
import { ShadingMethodBase } from "./ShadingMethodBase";
/**
 * EffectColorTransformMethod provides a shading method that changes the colour of a material analogous to a
 * ColorTransform object.
 */
var EffectColorTransformMethod = (function (_super) {
    tslib_1.__extends(EffectColorTransformMethod, _super);
    /**
     * Creates a new EffectColorTransformMethod.
     */
    function EffectColorTransformMethod(colorTransform) {
        if (colorTransform === void 0) { colorTransform = null; }
        var _this = _super.call(this) || this;
        _this._colorTransform = colorTransform;
        return _this;
    }
    Object.defineProperty(EffectColorTransformMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectColorTransformMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectColorTransformMethod.prototype, "colorTransform", {
        /**
         * The ColorTransform object to transform the colour of the material with.
         */
        get: function () {
            return this._colorTransform;
        },
        set: function (value) {
            this._colorTransform = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    return EffectColorTransformMethod;
}(ShadingMethodBase));
export { EffectColorTransformMethod };
EffectColorTransformMethod.assetType = "[asset EffectColorTransformMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/EffectColorTransformMethod.js